import { Button, message, Space, Tag } from 'antd';
import { observer } from 'mobx-react';
import { RoleType } from 'permission/role/type/roleType';
import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import * as Component from '../../../../shared/components';
import { userService } from '../service/userService';
import { UserDetailType } from '../types/userType';

const UserPage: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  const fetchUser = async (
    params: URLSearchParams
  ): Promise<{ data: UserDetailType[]; count: number }> => {
    const userListWithRole = await userService.fetchUserListWithRole(params);
    return { data: userListWithRole.data, count: userListWithRole.count };
  };

  const columns = [
    {
      title: 'User ID',
      dataIndex: 'username',
      key: 'username',
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
    },
    {
      title: 'Organization',
      dataIndex: 'company',
      key: 'company_id',
      render: (_text: string, record: UserDetailType): React.ReactNode => {
        return <div>{record.company?.title || '-'}</div>;
      },
    },
    {
      title: 'Role',
      dataIndex: 'roles',
      key: 'roles',
      render: (_text: string, record: UserDetailType): React.ReactNode => {
        return (
          <div style={{ display: 'flex', gap: '4px', flexWrap: 'wrap' }}>
            {record.roles.map((role: RoleType) => (
              <Tag key={role.id} color="blue">
                {role.name}
              </Tag>
            ))}
          </div>
        );
      },
    },
    {
      title: 'Actions',
      key: 'action',
      dataIndex: 'action',
      render: (_text: string, record: UserDetailType): React.ReactNode => (
        <Space size="middle">
          <Button key="edit" onClick={() => navigate(`/user/edit/${record.id}`)}>
            Edit
          </Button>
          <Button key="delete" onClick={() => message.info('You do not have permission')}>
            Delete
          </Button>
        </Space>
      ),
    },
  ];

  const AddButton = (): JSX.Element => {
    return (
      <Component.CustomButtonComponent
        text={`+ Add User`}
        onClick={() => navigate('/user/add')}
        size={'small'}
      />
    );
  };

  return (
    <Component.BasePageComponent>
      <Component.TableComponent<UserDetailType>
        name="User"
        searchParams={searchParams}
        setSearchParams={setSearchParams}
        columns={columns}
        dataFetch={fetchUser}
        additionalButton={[AddButton()]}
      />
    </Component.BasePageComponent>
  );
};

export default observer(UserPage);
